module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.7428/img/storefront-header-blobs.svg"